import {paginationSummaryFormatter} from "@/utils/PaginationUtils";
import {IntlShape} from "react-intl";
import {DataTableProps} from "peggirkit/dist/components/Table/DataTable/DataTable";


export const globalDataTableProps = <T>(
    intl: IntlShape,
): Pick<DataTableProps<T>, "paginationControl" | "size" | "breakpoints"> => ({
    paginationControl: {
        navType: {
            type: "prevNext"
        },
        paginationSummaryFormatter: paginationSummaryFormatter(intl),
        breakpoints: {
            sm: {
                navType: {
                    type: "buttons",
                },
            },
        },
    },
    size: "compact",
    breakpoints: {
        md: {
            size: "normal"
        }
    },
});